/**
 * 简体中文 dictionary — keys are the English source strings.
 * Station/stop names for zh-cn are converted from Traditional via the
 * generated char map (public/data/zh-simplify-map.json), not here.
 */
export const zhCn = {
  "(Hong Kong time, UTC+8). Live clock.": "（香港时间，UTC+8）。实时时钟。",
  "(Hong Kong time, UTC+8). Reset returns to live clock.": "（香港时间，UTC+8）。重置会返回实时时钟。",
  "(UTC+8). Reset returns to Now.": "（UTC+8）。重置将回到「现在」。",
  "(merged official stops + OSRM densify).": "（已合并官方站点 + OSRM 加密点）。",
  "(orange). Official stop coords stay fixed (grey ghosts) for identity / merge.": "（橙色）。官方站点坐标保持固定（灰色残影）以维持身份／合并。",
  "*You might still need short station access if you disabled Walk. Plans to a stop/station itself stay listed.": "*若你关闭步行，仍可能需要短程车站接驳。计划到站／车站本身仍会列出。",
  ", and": "，以及",
  ", you can load a calculated path and edit turning points for moderators to review.": "，你可以加载计算路径并编辑转弯点，供版主审查。",
  "0 path pts": "0 个路径点",
  "@Bus": "@巴士",
  "@LRT": "@轻铁",
  "@MTR": "@港铁",
  "AEL": "机场快线",
  "bus": "巴士",
  "About": "关于",
  "About Travelers": "关于 Travelers",
  "Add via": "添加途经",
  "Airport Express (AEL)": "机场快线（AEL）",
  "Alight": "下车",
  "Alight match": "下车匹配",
  "All done!": "全部完成！",
  "All done! Let's start enjoying your trip with Travelers!": "全部完成！让我们一起享受您的 Travelers 旅程吧！",
  "All modes": "所有模式",
  "All operators": "所有运营商",
  "Allow location for origin, or set From manually": "允许位置作为起点，或手动设置起点",
  "Also fetches ETAs at the nearest stops and every 5th stop ahead and behind the selected stop, so positions are stitched from more anchors (extra requests per route view).": "也会在最近的站点，以及所选站点前后每隔 5 个站点获取 ETA，使位置可从更多锚点拼接（每个路线视图会多一些请求）。",
  "App opens the PR with the site bot token (no GitHub login).": "应用会用网站 bot token 打开 PR（无需 GitHub 登录）。",
  "App sections": "应用章节",
  "Application code © UNLOOP MORGAN 2026. Apache 2.0 does not grant trademark rights. “MORGAN”, “Travelers”, logos, and product naming may not be reused without permission.": "应用代码 © UNLOOP MORGAN 2026。Apache 2.0 不授予商标权。「MORGAN」、「Travelers」、标志与产品名称未经许可不得再用。",
  "Auto-caches only the app shell (UI, fonts, icons) so ordinary use never burns mobile data. Fares, route/stop data and the basemap are downloaded only when you press “Download offline data” below (≈ 55 MB) — press the button again after updates to refresh it.": "仅自动缓存应用外壳（界面、字体、图标），日常使用不会消耗移动数据。车费、路线／站点数据和底图只在你按下下方「下载离线数据」时才会下载（约 55 MB）——更新后请再按一次按钮以刷新。",
  "Back": "返回",
  "Back online": "已恢复连接",
  "Back to search": "返回搜索",
  "Back to trip": "返回行程",
  "Balanced": "平衡",
  "Basemap style and layer definitions (Protomaps).": "底图样式与图层定义（Protomaps）。",
  "Basemap tiles generated from OpenStreetMap (via hk-pmtiles-generation) and served from the Travelers data edge.": "底图瓦片由 OpenStreetMap 生成（经 hk-pmtiles-generation），由 Travelers 数据边缘提供。",
  "Beta": "测试版",
  "Beta Feature": "测试版功能",
  "Beta Features": "测试版功能",
  "Beta banner enabled": "测试版横幅已启用",
  "Beta banner hidden": "测试版横幅已隐藏",
  "Beta features": "测试版功能",
  "Beta warning banner": "测试版提示横幅",
  "Board": "上车",
  "Board match": "上车匹配",
  "Board/alight name fragments required (auto-filled after Load path).": "需要上车／下车名称片段（加载路径后会自动填入）。",
  "Bot account": "Bot 账户",
  "Box-select path points / offsets (B)": "框选路径点／偏移（B）",
  "Branch": "支线",
  "Build and toolchain": "构建与工具链",
  "Build tool (VoidZero Inc. and Vite contributors).": "构建工具（VoidZero Inc. 与 Vite 贡献者）。",
  "Bus": "巴士",
  "Bus · {cos}": "巴士 · {cos}",
  "Bus / GMB routes, stops and fares (FARE, ROUTE, RSTOP, STOP tables) plus realtime ETAs (rt.data.gov.hk, data.etabus.gov.hk).": "巴士／小巴路线、站点与车费（FARE、ROUTE、RSTOP、STOP 表），以及实时 ETA（rt.data.gov.hk、data.etabus.gov.hk）。",
  "Bus companies": "巴士公司",
  "Bus company": "巴士公司",
  "Bus paths are drawn live from the road network and can miss real alignments (e.g. Mei Tung Street vs the bus terminus). On": "巴士路线会实时沿道路网络绘制，可能与真实走线有出入（例如美东街对比巴士总站）。开",
  "Bus: route no. · MTR: line code (TWL, ISL, TCL…) · AEL · LRT: route no. (505) · GMB: route code (auto region search)": "巴士：路线编号 · 港铁：路线代码（TWL、ISL、TCL…）· AEL · 轻铁：路线编号（505）· 小巴：路线代码（自动地区搜索）",
  "CTB": "城巴",
  "Cache": "缓存",
  "Cache all data": "缓存所有数据",
  "Cache data on device": "在设备上缓存数据",
  "Cache transit data on this device for offline use and mobile data savings.": "在本机缓存交通数据，用于离线使用并节省移动数据。",
  "Cache: checking…": "缓存：检查中…",
  "Cancel": "取消",
  "Cannot delete path endpoints": "无法删除路径端点",
  "Change platforms": "换乘月台",
  "Change platforms at {station}": "在 {station} 换乘月台",
  "Check your connection and try again": "请检查连接后重试",
  "Checking edge metadata…": "检查边缘元数据…",
  "China T-Union Cards": "交通联合卡",
  "Choose how to open a review PR on": "选择在何处打开审查 PR 的方式",
  "Choose operator + route →": "选择运营商 + 路线 →",
  "Choose your default fare ticket type for trip plans.": "选择规划行程时用于估算车费的默认票种。",
  "Choose your preferred language": "选择您偏好的语言",
  "Circular": "循环",
  "Citybus": "城巴",
  "Citybus (CTB)": "城巴（CTB）",
  "Clear": "清除",
  "Clear selection": "清除选择",
  "Clear via": "清除途经",
  "Click anywhere on the map for {field}": "在地图上任意位置点击，设置{field}",
  "Close": "关闭",
  "Cloud": "云端",
  "Cloud: live data first, downloaded copy as the offline fallback. Local: serve the downloaded copy directly to save mobile data.": "云端：优先使用实时数据，已下载副本作为离线后备。本机：直接使用已下载副本以节省移动数据。",
  "Community data feed": "社区数据源",
  "Concessionary fare on domestic routes; excl. AEL, EAL First Class, Lo Wu & Lok Ma Chau": "市区线路优惠票价；不含 AEL、东铁头等、罗湖与落马洲",
  "Confirm": "确认",
  "Confirm (Enter) or Revert (Esc) Follow roads first": "请先确认（Enter）或还原（Esc）沿路行驶",
  "Confirm or Revert Follow roads first": "请先确认或还原沿路行驶",
  "Confirm or Revert the current Follow roads result first": "请先确认或还原当前的沿路行驶结果",
  "Confirm or Revert the path first": "请先确认或还原路径",
  "Contactless Bank Cards": "非接触式银行卡",
  "Contribute": "贡献",
  "Contribute closed — desktop only": "贡献已关闭 —— 仅限桌面版",
  "Contribute route path": "贡献路线路径",
  "Copy JSON": "复制 JSON",
  "Could not copy — use Download instead": "无法复制 —— 请改用下载",
  "Could not get location": "无法获取位置",
  "Could not import JSON": "无法导入 JSON",
  "Could not load route path": "无法加载路线路径",
  "Could not reach data edge.": "无法连接数据边缘。",
  "Could not reach the submit API.": "无法连接到提交 API。",
  "Could not resolve LRT coords for route {r}": "无法解析路线 {r} 的轻铁坐标",
  "Couldn’t load nearby routes": "无法加载附近路线",
  "Couldn’t load routes": "无法加载路线",
  "Current location": "当前位置",
  "Data cache": "数据缓存",
  "Data cache enabled": "已启用离线数据缓存",
  "Data update available": "有可用的数据更新",
  "Data: MTR open data · Protomaps · OpenStreetMap contributors.": "数据：港铁开放数据 · Protomaps · OpenStreetMap 贡献者。",
  "Dataset status": "数据集状态",
  "Default:": "默认：",
  "Delete ({n})": "删除（{n}）",
  "Delete All Data on This Device": "删除此设备上的所有数据",
  "Delete all data": "删除所有数据",
  "Delete all data?": "删除所有数据？",
  "Delete selected": "删除已选",
  "Deleted {n} points": "已删除 {n} 个点",
  "Deleted {n} points · {m} remain · Undo available": "已删除 {n} 个点 · 剩余 {m} 个 · 可撤销",
  "Deletes every cached byte, preference and onboarding state, then restarts the app.": "删除所有缓存数据、偏好设置和引导状态，然后重新启动应用。",
  "Densifying segments OSRM can handle…": "正在加密路段，让 OSRM 可以处理…",
  "Departure": "出发",
  "Departure · Now (UTC+8)": "出发 · 现在（UTC+8）",
  "Departure · {label}": "出发 · {label}",
  "Departure time (Hong Kong, UTC+8)": "出发时间（香港，UTC+8）",
  "Departure · {time}": "出发 · {time}",
  "Desktop only · mouse/trackpad recommended.": "仅限桌面 · 建议使用鼠标／触控板。",
  "Destination": "目的地",
  "Developer": "开发者",
  "Direction": "方向",
  "Done": "完成",
  "Download GTFS": "下载 GTFS",
  "Download JSON": "下载 JSON",
  "Download JSON copy": "下载 JSON 副本",
  "Download PMTiles": "下载 PMTiles",
  "Download failed": "下载失败",
  "Download offline data": "下载离线数据",
  "Download or copy the JSON and share it with moderators if needed.": "如有需要，请下载或复制 JSON 并分享给版主。",
  "Downloading offline data…": "正在下载离线数据…",
  "Downloads": "下载",
  "Drag a box on the map · +drag to add · amber = offset from route · red = selected · remove": "在地图上拖曳框选 · +拖曳以添加 · 琥珀色 = 偏离路线 · 红色 = 已选 · 移除",
  "Draw or load a path first (need ≥ 2 points)": "请先绘制或加载路径（需要 ≥ 2 个点）",
  "Drawing route…": "绘制路线中…",
  "Drop a .json contribution file": "放入一个 .json 贡献文件",
  "E2E testing only — not shipped in the app bundle.": "仅限 E2E 测试——不会随应用包发布。",
  "EAL First Class": "东铁头等",
  "ETA route browser": "ETA 路线浏览器",
  "ETA unavailable · checked {t}": "ETA 不可用 · {t} 检查",
  "East Rail Line First Class": "东铁线头等",
  "Edit mode": "编辑模式",
  "Edit path turns (hollow green) and/or": "编辑路径转弯点（空心绿色）及／或",
  "Enable": "启用",
  "Enter a Destination/Route": "输入目的地／路线",
  "Enter a route number (e.g. 38, S1, E11).": "输入路线编号（例如 38、S1、E11）。",
  "Enter an MTR line code: TWL, ISL, KTL, TML, EAL, TCL, TKL, SIL, DRL, AEL": "输入港铁路线代码：TWL、ISL、KTL、TML、EAL、TCL、TKL、SIL、DRL、AEL",
  "Est. arrive": "预计到达",
  "Estimated arrival (Hong Kong time)": "预计到达时间（香港时间）",
  "Expand or collapse": "展开或收起",
  "Expand or collapse panel": "展开或收起面板",
  "Fare": "车费",
  "Fare · {type}": "车费 · {type}",
  "Fare tables unavailable — times still work": "车费表不可用——时间仍然有效",
  "Fares, line / LRT routes and stops, MTR Bus schedules.": "车费、线路／轻铁路线与站点、港铁巴士时刻表。",
  "Fastest": "最快",
  "Fetch more live data": "获取更多实时数据",
  "Fetch more live data disabled": "已关闭「获取更多实时数据」",
  "Fetch more live data enabled": "已开启「获取更多实时数据」",
  "Fetch the full dataset for offline use. This will be the main data source if preferred in the “Prefer data source” setting above.": "下载完整数据集以供离线使用。若在上方「偏好数据来源」设置中选中，这将是主要数据来源。",
  "Fewer transfers preferred": "偏好较少换乘",
  "Filter stops:": "筛选站点：",
  "Finishing…": "完成中…",
  "First-party code": "自有代码",
  "Fixed time": "指定时间",
  "Follow roads": "沿道路",
  "Follow roads calculation": "沿道路计算",
  "Follow roads confirmed": "已确认沿路行驶",
  "Follow roads confirmed · {n} path pts · Undo still available · Hide overlay when done": "已确认沿路行驶 · {n} 个路径点 · 仍可撤销 · 完成后隐藏叠加层",
  "Follow roads reverted": "已还原沿路行驶",
  "Follow roads reverted · {n} path pts restored": "已还原沿路行驶 · 已恢复 {n} 个路径点",
  "Recalculate path": "重新计算路径",
  "Recalc preview: {ins} road pts via {n} section(s) · {before}→{after} pts — Confirm or Revert": "重新计算预览：沿道路重排 {ins} 个点 · {n} 段 · {before}→{after} 个点——请确认或还原",
  "Couldn't reroute along roads — OSRM is unavailable. Path unchanged.": "无法沿道路重新排线——OSRM 不可用。路径保持不变。",
  "Recalculate needs a connection — you appear to be offline.": "重新计算需要网络连接——你似乎已离线。",
  "Road assistant: recalculating section {i}/{n}…": "道路助手：正在重新计算第 {i}/{n} 段…",
  "Road assistant stopped: OSRM is rate-limiting or down — try again in a minute.": "道路助手已停止：OSRM 正在限流或不可用——请一分钟后再试。",
  "Follow-roads overlay hidden": "已隐藏沿路行驶叠加层",
  "Add blocker": "添加阻挡点",
  "Blocker added": "已添加阻挡点",
  "Blocker added — Follow roads will avoid this junction": "已添加阻挡点——沿道路会避开此路口",
  "Blocker already there": "此处已有阻挡点",
  "Blocker placement off": "已停止放置阻挡点",
  "Blocker removed": "已移除阻挡点",
  "Blockers cleared": "已清除阻挡点",
  "blockers": "阻挡点",
  "Cannot set the first point as last": "不能把第一个点设为终点",
  "Clear blockers": "清除阻挡点",
  "Click the map to drop a blocker": "在地图上点击放置阻挡点",
  "Focused point {n} · 1 = start here · 2 = last here": "已选第 {n} 点 · 1 = 此处为起点 · 2 = 此处为终点",
  "Junction blocker (avoid this road)": "路口阻挡点（避开这条路）",
  "Line now ends here": "路线现在在此处结束",
  "Line start moved here": "路线起点已移到此处",
  "loop": "循环",
  "Mode: Path turns (V) — drag rings · arrows show direction · 1 start · 2 last": "模式：路径转弯（V）——拖动圆环 · 箭头显示方向 · 1 起点 · 2 终点",
  "Mode: Select (B) — box-select · Follow roads snaps selected only": "模式：选择（B）——框选 · 沿道路只吸附已选点",
  "Need a focused path point — click a green ring first": "请先点击一个绿色圆环再选起点／终点",
  "Zoom Chord": "放大贴路",
  "Zoom Chord disabled": "已关闭放大贴路",
  "Zoom Chord enabled": "已开启放大贴路",
  "On non-contributed bus routes, road-snap the GTFS line onto OpenStreetMap roads when you zoom in. Uses the on-device street graph with OSRM only as backup.": "未贡献路径的巴士线，放大地图时会将 GTFS 线贴到 OpenStreetMap 道路。使用设备内街道图计算，OSRM 仅作后备。",
  "Path already ends here": "路线已在此处结束",
  "Path already starts here": "路线已从此处开始",
  "Path end set · {n} pts remain": "已设终点 · 剩余 {n} 个路径点",
  "Path mode: drag rings · click a ring then 1/2 for start/last · Shift+click blocker · R Follow roads": "路径模式：拖动圆环 · 点击圆环再按 1/2 设起点／终点 · Shift+点击添加阻挡点 · R 沿道路",
  "Path rotated · this point is now the start": "已旋转路径 · 此点现在是起点",
  "Placing blockers — click the wrong road at a junction · Esc to stop": "放置阻挡点——点击路口走错的那一侧 · Esc 停止",
  "Select mode: Follow roads snaps selected points only. Select some, or leave Select mode to snap all.": "选择模式：沿道路只吸附已选点。请先选点，或离开选择模式以吸附整条线。",
  "Select mode: box-select · Follow roads snaps selected points only · Del removes": "选择模式：框选 · 沿道路只吸附已选点 · Del 删除",
  "Select mode (B) — Follow roads snaps selected points only": "选择模式（B）——沿道路只吸附已选点",
  "Select points first, or press V to snap the whole path": "请先选点，或按 V 吸附整条路径",
  "Service disruption": "服务受阻",
  "Set as last": "设为终点",
  "START": "起",
  "END": "终",
  "Start here": "此处为起点",
  "Cutoff stop (by sequence — not the overlapping pin)": "分界站（按站序——不要点重叠的针）",
  "hidden": "已隐藏",
  "Previous stop": "上一站",
  "Next stop": "下一站",
  "Hide before": "隐藏之前",
  "Hide after": "隐藏之后",
  "Show all": "显示全部",
  "Showing all": "已显示全部",
  "Showing all stops and path": "已显示全部站点和路径",
  "Click a stop pin first, then Hide before / Hide after": "请先点击一个站点，再隐藏之前／之后",
  "Nothing before the first stop": "第一个站之前没有可隐藏的内容",
  "Nothing after the last stop": "最后一个站之后没有可隐藏的内容",
  "showing {n}/{m}": "显示 {n}/{m}",
  "Showing from #{n} {name} · hidden {k} stops before · 0 to show all": "从 #{n} {name} 起显示 · 已隐藏之前 {k} 站 · 0 显示全部",
  "Showing through #{n} {name} · hidden {k} stops after · 0 to show all": "显示到 #{n} {name} · 已隐藏之后 {k} 站 · 0 显示全部",
  "Focused stop #{n} {name} · [ hide before · ] hide after · 0 show all": "已选 #{n} {name} · [ 隐藏之前 · ] 隐藏之后 · 0 显示全部",
  "Mode: Visual stops (S) — click a stop then [ hide before / ] hide after": "模式：视觉站点（S）——点击站点再 [ 隐藏之前 / ] 隐藏之后",
  "Visual stops: click a pin then [ / ] to hide the other half of a circular · drag to adjust": "视觉站点：点击针再 [ / ] 隐藏循环线另一半 · 拖曳调整",
  "Fonts": "字体",
  "Free MTR link": "港铁免费通道",
  "Free MTR link: {from} → {to}": "港铁免费通道：{from} → {to}",
  "From": "起点",
  "From plan": "从计划",
  "Full route": "全程",
  "GMB": "小巴",
  "GMB (green minibus)": "小巴（绿色专线小巴）",
  "GMB route code required": "需要小巴路线代码",
  "GMB route {code} not found. Try the public code (e.g. 1, 44A).": "找不到小巴路线 {code}。请尝试公开代码（例如 1、44A）。",
  "GTFS feed builder (© 2025 Wheels Transit) behind hk.gtfs.zip and the routing graph; feed data is derived from the government sources above.": "GTFS 数据源构建器（© 2025 Wheels Transit），位于 hk.gtfs.zip 与路线规划图背后；数据源内容衍生自上述政府来源。",
  "GTFS → .wheelsrouter graph compiler, run in CI (wheels-router-nano ecosystem; not shipped).": "GTFS → .wheelsrouter 路线图编译器，在 CI 中运行（wheels-router-nano 生态；不会随应用发布）。",
  "Getting your location…": "正在获取你的位置…",
  "GitHub Repository": "GitHub 仓库",
  "GitHub account": "GitHub 账户",
  "GitHub login failed": "GitHub 登录失败",
  "GitHub login finished": "GitHub 登录完成",
  "GitHub login required": "需要 GitHub 登录",
  "Gov open data terms": "政府开放数据条款",
  "Green minibus routes, stops and ETAs.": "绿色专线小巴路线、站点与 ETA。",
  "Hide ETA to browse the full stop list": "隐藏 ETA 以浏览全部站点",
  "Hide beta banner for this session": "本次使用期间隐藏测试版横幅",
  "Hide beta banner?": "隐藏测试版横幅？",
  "Hide calculation overlay": "隐藏计算叠加层",
  "High (more data)": "高（更多数据）",
  "High accuracy": "高准确度",
  "Holiday": "假日",
  "Hong Kong Community GTFS": "香港社区 GTFS",
  "Hong Kong map": "香港地图",
  "Hong Kong transit map & trip planner. Routes use the public GTFS graph (RAPTOR) with Octopus adult fare estimates. Search supports": "香港交通地图与行程规划。路线使用公开 GTFS 路线图（RAPTOR），附八达通成人车费估算。搜索支持",
  "I agree to all terms and policies": "我同意所有条款和政策",
  "I agree to the Terms of Service and Privacy Policy": "我同意服务条款及隐私政策",
  "I understand": "我了解",
  "Import JSON": "导入 JSON",
  "Import a downloaded contribution JSON to continue editing": "导入已下载的贡献 JSON 以继续编辑",
  "Import failed": "导入失败",
  "Imported JSON · {n} points": "已导入 JSON · {n} 个点",
  "Imported {id} · {n} path pts · {m} visual stops · continue editing": "已导入 {id} · {n} 个路径点 · {m} 个视觉站点 · 继续编辑",
  "In-station interchange": "站内换乘",
  "In-station interchange at {place}": "站内换乘，在 {place}",
  "Inbound / I / DOWN / seq 2": "回程／I／DOWN／seq 2",
  "Indoor interchange": "室内换乘",
  "Indoor interchange: {from} → {to}": "室内换乘：{from} → {to}",
  "Invalid JSON object": "无效的 JSON 对象",
  "Invalid place": "无效地点",
  "JSON copied": "已复制 JSON",
  "JSON copied to clipboard": "已复制 JSON 到剪贴板",
  "JSON downloaded": "已下载 JSON",
  "JSON needs coordinates with at least 2 [lon,lat] points": "JSON 需要至少 2 个 [lon,lat] 坐标点",
  "JoyYou $2/20% scheme; full adult for AEL, Lo Wu, Lok Ma Chau & Racecourse": "乐悠卡 $2／20% 优惠；AEL、罗湖、落马洲与马场收成人票价",
  "KMB": "九巴",
  "KMB / Citybus": "九巴／城巴",
  "KMB / LWB": "九巴／龙运",
  "KMB/LWB": "九巴／龙运",
  "Keep banner": "保留横幅",
  "LIVE": "实时",
  "LRT": "轻铁",
  "LRT route CSV empty": "轻铁路线 CSV 为空",
  "LRT route number required (e.g. 505, 507, 610)": "需要轻铁路线编号（例如 505、507、610）",
  "LWB": "龙运巴士",
  "Language": "语言",
  "Language · {label}": "语言 · {label}",
  "Last point removed": "已移除最后一个点",
  "Later": "稍后",
  "Least fare": "车费最低",
  "Licenses": "许可证",
  "Light Rail": "轻铁",
  "Light Rail (LRT)": "轻铁（LRT）",
  "Live": "实时",
  "Live ETAs · {liveN}/{total} routes · {t} · refreshes every 1 min": "实时 ETA · {liveN}/{total} 条路线 · {t} · 每 1 分钟更新",
  "Live ETAs failed — will retry": "实时 ETA 失败——将重试",
  "Live OSRM path · {stops} stops · {n} pts (no matching published path). Press R to follow roads.": "实时 OSRM 路径 · {stops} 个站点 · {n} 个点（没有匹配的已发布路径）。按 R 沿路行驶。",
  "Live Position Engine": "实时位置引擎",
  "Live Position Engine (Prediction-based)": "实时位置引擎（预测）",
  "Live Position Engine disabled": "已关闭实时位置引擎",
  "Live Position Engine enabled": "已开启实时位置引擎",
  "Live arrivals": "实时到站",
  "Live bus positions": "实时巴士位置",
  "Live bus positions disabled": "已关闭实时巴士位置",
  "Live bus positions enabled": "已开启实时巴士位置",
  "Live est. arrive": "实时预计到达",
  "Live {liveN} · Scheduled {schedN} · {total} routes · {t}": "实时 {liveN} · 预定 {schedN} · 共 {total} 条路线 · {t}",
  "Load a calculated path or draw at least 2 points.": "加载计算路径或绘制至少 2 个点。",
  "Load a path first": "请先加载路径",
  "Load calculated path": "加载已计算路径",
  "Load failed": "加载失败",
  "Load path": "加载路径",
  "Load path not supported for operator {ag} yet — use From plan or draw": "暂不支持运营商 {ag} 加载路径 —— 请使用“从计划”或自行绘制",
  "Loaded calculated path from plan ({n} pts). Follow roads (R) to hug streets, then edit.": "已从计划加载计算路径（{n} 个点）。按 R 沿路行驶以贴合街道，然后编辑。",
  "Loaded path from current plan": "已加载当前计划的路径",
  "Loading WASM router…": "加载 WASM 路线规划器…",
  "Loading nearby routes…": "加载附近路线中…",
  "Loading route…": "加载路线中…",
  "Loading routes…": "加载路线中…",
  "Loading stops + checking published overrides…": "加载站点 + 检查已发布覆写…",
  "Loading {co} {id}…": "加载中：{co} {id}…",
  "Loading {n} pinned route{s}…": "加载中：已固定 {n} 个站点{s}…",
  "Loading {n} pinned stop{s}…": "加载中：已固定 {n} 个站点{s}…",
  "Loads this route’s published override if any; otherwise a": "加载此路线的已发布覆写（如有）；否则加载",
  "Local": "本机",
  "Location permission denied": "位置权限被拒绝",
  "Location request timed out": "位置请求超时",
  "Location unavailable": "无法获取位置",
  "Log in and open a PR from": "登录并从",
  "Log in with GitHub": "使用 GitHub 登录",
  "Log in with GitHub first (or switch to Bot account)": "请先登录 GitHub（或切换到 Bot 账户）",
  "Log in with GitHub to submit with your account, or switch to Bot account.": "登录 GitHub 以用你的账户提交，或切换到 Bot 账户。",
  "Log out": "退出登录",
  "Logged out of GitHub": "已登出 GitHub",
  "Lower fare preferred": "偏好较低车费",
  "MTR": "港铁",
  "MTR (heavy rail)": "港铁（重型铁路）",
  "MTR Corporation open data": "港铁公司开放数据",
  "MTR ends": "港铁结束",
  "MTR open data terms": "港铁开放数据条款",
  "MTR preferred": "港铁优先",
  "Main": "主页",
  "Map": "地图",
  "Map data and services": "地图数据与服务",
  "Map error: {msg}": "地图错误：{msg}",
  "Map failed to load tiles": "地图无法加载瓦片",
  "Map ready · streaming hongkong.pmtiles": "地图就绪 · 流式加载 hongkong.pmtiles",
  "Map rendering engine (MapLibre contributors).": "地图渲染引擎（MapLibre 贡献者）。",
  "Map rendering paused — recovering…": "地图渲染暂停——恢复中…",
  "Map resumed": "地图已恢复",
  "Map unavailable": "地图不可用",
  "Map didn't recover — reloading…": "地图未恢复——重新加载中…",
  "Metadata unavailable — map may still load from PMTiles URL": "元数据不可用——地图仍可从 PMTiles URL 加载",
  "Minimise journey time": "缩短行程时间",
  "Mode": "模式",
  "Mode · {day}": "模式 · {day}",
  "Mode: Path turns (V) — drag hollow green rings": "模式：路径转弯点（V）——拖曳空心绿色圆环",
  "Modes · {methods}": "模式 · {methods}",
  "MTR Bus": "港铁巴士",
  "Meet at {place}": "在 {place} 会合",
  "Meet friends here": "在这里会合朋友",
  "Meet friends here (optional)": "在这里会合朋友（可选）",
  "Nearby": "附近",
  "A new version of MORGAN Travelers is ready. Reload now to get it?": "MORGAN Travelers 有新版本可用。现在重新加载以获取？",
  "Bus · {label}": "巴士 · {label}",
  "Data cache disabled — data source reset to Cloud": "已停用离线数据缓存 — 数据源重置为云端",
  "Fare · {fare}": "票价 · {fare}",
  "Mode · {mode}": "模式 · {mode}",
  "Modes · {modes}": "交通方式 · {modes}",
  "MORGAN Travelers (main app)": "MORGAN Travelers（主应用）",
  "N/A": "不适用",
  "NLB": "新大屿山巴士",
  "Need at least 2 path points": "至少需要 2 个路径点",
  "Next": "下一步",
  "No GMB stops for {code} seq {seq}": "找不到小巴 {code} 顺序 {seq} 的站点",
  "No LRT stops for route {r} direction {dir}. Check route no. (e.g. 505).": "找不到路线 {r} 方向 {dir} 的轻铁站。请检查路线编号（例如 505）。",
  "No departure": "无班次",
  "No departure data": "无班次数据",
  "No draft to copy": "没有可复制的草稿",
  "No draft to download": "没有可下载的草稿",
  "No large offsets found": "没有发现大型偏移",
  "No nearby routes": "附近没有路线",
  "No offset points over {m}m — path is clean enough": "没有超过 {m} 米的偏移点 —— 路径够干净",
  "No override for this route — using similar published path from {from} (shared corridor) · {n} pts. Edit & submit your own.": "此路线没有覆写 —— 使用来自 {from} 的类似已发布路径（共用走廊）· {n} 个点。编辑并提交你的版本。",
  "No places found": "找不到地点",
  "No places found — try “Yuen Long Station”, @MTR, or tap the map": "找不到地点 —— 试试“Yuen Long Station”、@MTR，或点击地图",
  "No places match “{q}”": "没有地点符合「{q}」",
  "No plan selected — search a route instead": "未选择计划 —— 请改为搜索路线",
  "No points in box (endpoints are protected)": "框中没有点（端点受保护）",
  "No points selected": "未选择任何点",
  "No routes found": "未找到路线",
  "No routes found — try other points": "未找到路线 — 请尝试其他地点",
  "No routes found through via — try another meeting point": "找不到经过此途经点的路线 — 请尝试另一个会合地点",
  "No routes found.": "未找到路线。",
  "No routes match “{q}”": "没有路线符合「{q}」",
  "No routes or places for “{q}”": "找不到“{q}”的路线或地点",
  "No station coords found for MTR {line}": "找不到 MTR {line} 的车站坐标",
  "No stop list for {co} {id}.": "没有 {co} {id} 的站点列表。",
  "No stops found for {ag} {r} ({dir})": "找不到 {ag} {r}（{dir}）的站点",
  "No transit legs for ETA": "没有可供 ETA 的交通路段",
  "No usable stops after merge for {ag} {r}": "合并后找不到 {ag} {r} 的可用站点",
  "No valid coordinates in JSON": "JSON 中没有有效坐标",
  "No {mode} stops matched — try another name": "没有匹配的 {mode} 站点 —— 试试其他名称",
  "No, use cloud only": "否，仅使用云端",
  "Not now": "暂不",
  "Notes for moderators": "版主备注",
  "Nothing in box": "框中没有内容",
  "Nothing to confirm": "没有可确认的内容",
  "Nothing to redo": "没有可重做的内容",
  "Nothing to revert": "没有可还原的内容",
  "Nothing to undo": "没有可撤销的内容",
  "Now": "现在",
  "Octopus Adult/Elderly": "八达通成人／长者",
  "Octopus Child": "八达通小童",
  "Octopus JoyYou Cards (60–64)": "乐悠卡（60–64 岁）",
  "Octopus JoyYou Cards (65+)": "乐悠卡（65 岁以上）",
  "Octopus Student": "八达通学生",
  "Off": "关",
  "Offline Data": "离线数据",
  "Offline data": "离线数据",
  "Offline — using downloaded data": "离线——使用已下载数据",
  "Offline data ready": "离线数据已就绪",
  "On": "开",
  "Onboarding": "入门引导",
  "Open source & data licenses": "开源与数据许可证",
  "Operator / mode": "运营商／模式",
  "Operator and route required": "需要运营商和路线",
  "Opposite": "对向",
  "Optional experimental features. You can change these anytime in Settings.": "可选的实验性功能。您随时可以在设置中更改。",
  "Origin": "起点",
  "Origin set to current location": "起点已设为当前位置",
  "Origin suggestions": "起点建议",
  "Original path (before)": "原始路径（之前）",
  "Other / joint": "其他／联营",
  "Outbound / O / UP / seq 1": "去程／O／UP／seq 1",
  "Outside service": "服务时间外",
  "Outside service hours": "服务时间外",
  "Override path loaded{id} · {n} pts": "已加载覆写路径{id} · {n} 个点",
  "Path cleared": "已清除路径",
  "Path contributions are desktop-only (wide screen + mouse/trackpad).": "路径贡献仅限桌面版（宽屏幕 + 鼠标／触控板）。",
  "Path loaded · {stops} stops · {n} pts (live densify)": "已加载路径 · {stops} 个站点 · {n} 个点（实时加密）",
  "Path mode: drag hollow green handles · click path to insert · Alt+click delete · B for select": "路径模式：拖动空心绿色手柄 · 点击路径以插入 · Alt+点击删除 · B 选择",
  "Path redone": "已重做路径",
  "Path turning points (V)": "路径转弯点（V）",
  "Path turns": "路径转弯",
  "Path turns mode (V)": "路径转向模式（V）",
  "Path unchanged — debug overlay shows why": "路径未变 —— 调试叠加层会显示原因",
  "Path undone": "已撤销路径",
  "Pick a via place from the list, or clear Via": "请从列表选择途经地点，或清除途经",
  "Planning via {place}…": "正在规划经 {place}…",
  "Planning…": "正在规划…",
  "Pin": "固定",
  "Pin plan": "置顶路线",
  "Pin route": "固定路线",
  "Pin stop": "固定站点",
  "Pin this route to the toolbar": "将此路线固定到工具栏",
  "Pin this stop": "固定此站点",
  "Pin this trip": "固定此行程",
  "Pinned": "已固定",
  "Pinned Routes": "已置顶站点",
  "Pinned Stops": "已置顶站点",
  "Pinned routes": "已固定站点",
  "Pinned stops": "已固定站点",
  "Pinned Trips": "已固定行程",
  "Nothing pinned yet": "尚未固定任何项目",
  "Pin trip plans from Plan Results, or open a route, pick a stop, then tap Pin.": "在规划结果固定行程，或打开路线选站后再点固定。",
  "Pin a route stop or trip plan": "固定站点或行程规划",
  "No pinned items": "没有固定项目",
  "Show detail": "显示详情",
  "Open pinned {id}": "打开已固定 {id}",
  "Open {n} pinned stops": "打开 {n} 个已固定站点",
  "Open {n} pinned trips": "打开 {n} 个已固定行程",
  "Open {n} pinned items": "打开 {n} 个已固定项目",
  "Place": "地点",
  "Place search / reverse geocoding (service).": "地点搜索／反向地理编码（服务）。",
  "Place search returned invalid JSON — is /geocode proxy running?": "地点搜索返回了无效 JSON —— /geocode proxy 是否正在运行？",
  "Places": "地点",
  "Places · tap to plan trip": "地点 · 点击规划行程",
  "Plan Results": "路线建议",
  "Plan failed: {msg}": "规划失败：{msg}",
  "Plan trip": "规划行程",
  "Platform {p}": "{p} 号月台",
  "Please get on the {noun} at {place}": "请在 {place} 搭乘{noun}",
  "Please get on the {noun} at {station}": "请在 {station} 搭乘{noun}",
  "Please review and accept all terms and policies to continue.": "请仔细阅读并接受所有条款和政策以继续。",
  "Please review and accept our Terms of Service and Privacy Policy to continue.": "请阅读并接受我们的服务条款及隐私政策，方可继续。",
  "Predicted bus positions (busPositionEngine, trafficSpeed, busSchedules). Source under GNU GPLv3 only; see licenses/GPL-3.0.txt.": "预测巴士位置（busPositionEngine、trafficSpeed、busSchedules）。源代码仅以 GNU GPLv3 授权；见 licenses/GPL-3.0.txt。",
  "Predicted Live Positions are for reference only.": "预测的实时巴士位置仅供参考。",
  "Prediction accuracy": "预测准确度",
  "Prefer": "偏好",
  "Prefer data source": "偏好数据来源",
  "Prefer {label}": "偏好：{label}",
  "Prefer {prefer} data": "偏好 {prefer} 数据",
  "Prefer {prefs}": "偏好 {prefs}",
  "Preparing manifest…": "准备清单中…",
  "Preparing offline data…": "准备离线数据中…",
  "Preview only —": "仅预览——",
  "Preview: {snap} snapped · {raw} raw · {dens} densified · {fail} kept · {before}→{after} pts — Confirm or Revert": "预览：{snap} 个已吸附 · {raw} 个原始 · {dens} 个加密 · {fail} 个保留 · {before}→{after} 点 —— 确认或还原",
  "Privacy Policy": "隐私政策",
  "Profile": "个人资料",
  "Profile menu": "个人资料菜单",
  "Published override loaded{id} · {n} path pts · {stops} stops. Edit & re-submit to improve, or Follow roads (R).": "已加载已发布覆写{id} · {n} 个路径点 · {stops} 个站点。编辑并重新提交以改善，或沿路行驶（R）。",
  "QR Code Adult/Elderly": "二维码成人／长者",
  "QR Code Child": "二维码小童",
  "RBS": "居民巴士",
  "Re-run onboarding": "重新执行入门引导",
  "Recommended": "推荐",
  "Redo": "重做",
  "Redo (⌘/Ctrl+Shift+Z or ⌘/Ctrl+Y)": "重做（⌘/Ctrl+Shift+Z 或 ⌘/Ctrl+Y）",
  "Redo · {n} path pts · {u} undo · {r} redo": "重做 · {n} 个路径点 · 可撤销 {u} 次 · 可重做 {r} 次",
  "Reload": "重新加载",
  "Reload now to fully apply the new language?": "重新加载即可完整应用新语言。立即重新加载？",
  "Reload once so the service worker is active": "重新加载一次以启用 service worker",
  "Reload to apply language?": "重新加载以应用语言？",
  "Required for “GitHub account” submit.": "使用「GitHub 账户」提交时需要。",
  "Reset departure time to now": "将出发时间重置为现在",
  "Reset to now (UTC+8)": "重置为现在（UTC+8）",
  "Residents' Bus Services (RBS, e.g. Ma Wan NR330/NR332 and Discovery Bay DB routes) charge a lower fare when paying with a registered Octopus card. Off = visitor fare.": "居民巴士服务（RBS，例如马湾 NR330/NR332 与愉景湾 DB 路线）使用已登记八达通卡付款时收费较低。关 = 访客车费。",
  "Restart now": "立即重新加载",
  "Restart to load the latest data from the cloud.": "重新加载以获取云端最新数据。",
  "Resume a downloaded draft (or drop a": "恢复已下载的草稿（或将",
  "Restored your in-progress edit": "已恢复你未完成的编辑",
  "Retry": "重试",
  "Revert": "还原",
  "Review the map · Confirm to keep · Revert to undo": "检查地图 · 确认以保留 · 还原以取消",
  "Ride {n} stop{s}": "搭乘 {n} 个站",
  "Road assistant failed": "道路助手失败",
  "Road assistant: nothing changed — see map legend (grey=original, amber=kept raw).": "道路助手：没有任何改变 —— 请参考地图图例（灰色=原本，琥珀色=保留原始）。",
  "Road assistant: snapping vertices onto streets (keeps all your points)…": "道路助手：正在将顶点吸附到街道（保留你所有点）…",
  "Road assistant: {msg}": "道路助手：{msg}",
  "Road-network geometry for bus-route snapping (service; data © OSM contributors).": "巴士路线贴路用的道路网络几何（服务；数据 © OSM 贡献者）。",
  "Route / fare dataset used for GMB and ferry fare fallbacks; used per its citation notice (HK Bus Crawling @2021).": "用于小巴与渡轮车费后备的路线／车费数据集；按其引用声明使用（HK Bus Crawling @2021）。",
  "Route / line": "路线／线路",
  "Route detail": "路线详情",
  "Route detail actions": "路线详情操作",
  "Route preferences": "路线偏好",
  "Router failed: {msg}": "路线引擎失败：{msg}",
  "Router graph failed to load": "路线规划图加载失败",
  "Routes": "路线",
  "Runtime open source": "运行时开源",
  "Same rates as Octopus Adult": "与八达通成人相同收费",
  "Same rates as Octopus Adult/Elderly": "与八达通成人／长者相同收费",
  "Same rates as Octopus Child": "与八达通小童相同收费",
  "Sched": "预定",
  "SCHEDULED": "预定",
  "Saved locally to the overrides pending folder. Open the review page or merge via npm run overrides:merge.": "已保存到本地 overrides pending 文件夹。打开审查页面，或运行 npm run overrides:merge 合并。",
  "Scheduled departures": "预定发车",
  "Search": "搜索",
  "Search destination or route": "搜索目的地或路线",
  "Search failed": "搜索失败",
  "Search unavailable — run npm run dev (needs /geocode proxy), or tap the map": "搜索不可用 —— 运行 npm run dev（需要 /geocode proxy），或点击地图",
  "Searching…": "搜索中…",
  "Segment densified + inserted mids": "路段加密并插入中点",
  "Segment left as-is": "路段保持原样",
  "Segment {n}/{total}": "路段 {n}/{total}",
  "Select": "选择",
  "Select a route first": "请先选择路线",
  "Select an operator / mode (KMB, GMB, MTR, AEL, LRT, …).": "选择运营商／模式（KMB、GMB、MTR、AEL、LRT、…）。",
  "Select at least one bus company": "请至少选择一家巴士公司",
  "Select at least one preference": "请至少选择一个偏好",
  "Select at least one traffic method": "请至少选择一种交通工具",
  "Select mode (B)": "选择模式（B）",
  "Select mode (B) — box-select offset points": "选择模式（B）—— 框选偏移点",
  "Select mode (B) — box-select · O for offsets": "选择模式（B）—— 框选 · O 选偏移",
  "Select mode: drag a box on the map · amber = offset >{n}m · Delete/Backspace removes selected": "选择模式：在地图上拖出一个框 · 琥珀色 = 偏移 >{n} 米 · Delete/Backspace 移除所选",
  "Select offsets": "选择偏移",
  "Select operator and enter route number first": "请先选择运营商并输入路线编号",
  "Selected {n} offset points (>{m}m from route backbone). Delete to clean, or box-select more.": "已选择 {n} 个偏移点（距离路线主线 >{m} 米）。删除以清理，或再框选更多。",
  "Selection cleared": "已清除选择",
  "Select…": "选择…",
  "Service day mode": "服务日模式",
  "Settings": "设置",
  "Show ETA at this stop": "显示此站点 ETA",
  "Show live bus markers predicted from nearby ETA countdowns.": "根据附近车站的到站时间推算并显示巴士实时位置标记。",
  "Show live markers predicted from nearby ETA countdowns.": "根据附近车站的到站时间推算并显示实时位置标记。",
  "Show live markers on bus route maps — estimates stitched from the ETA countdowns of nearby stops, not official GPS.": "在巴士路线地图显示实时标记——估算由附近站点的 ETA 倒计时拼接而成，并非官方 GPS。",
  "Show live markers on route maps — estimates stitched from the ETA countdowns of nearby stops, not official GPS.": "在路线地图显示实时标记——估算由附近站点的 ETA 倒计时拼接而成，并非官方 GPS。",
  "Show route details": "显示路线详情",
  "Show the “Beta Feature” disclaimer while live bus positions are active. Swipe the banner up to hide it for the session.": "启用实时巴士位置时显示「测试版功能」声明。向上滑走横幅以在本次使用期间隐藏。",
  "Show the “Beta Feature” disclaimer while the Live Position Engine is active. Swipe the banner up to hide it for the session.": "启用实时位置引擎时显示「测试版功能」声明。向上滑走横幅以在本次使用期间隐藏。",
  "Showing @{mode} stops": "显示 @{mode} 站点",
  "Signed in as @{login}": "已以 @{login} 登录",
  "Similar override ({from}) · {n} pts": "类似覆写（{from}）· {n} 个点",
  "Simplest": "最简单",
  "Single Ride Ticket/Cash": "单程车票／现金",
  "Skip": "跳过",
  "Skipped a via that is too close to another point": "已跳过与其他点过近的途经",
  "Snap link (old → new)": "贴路链接（旧 → 新）",
  "Snap visuals": "贴路视觉",
  "Snap your path onto nearby road edges only — does not re-route (R)": "只会将路径贴到附近道路边缘——不会重新规划路线（R）",
  "Snapping vertices to nearest road…": "正在将顶点吸附到最近的道路…",
  "Snaps your vertices onto nearby streets. Never deletes points — only adds road detail where OSRM can; weak sections stay as you drew them. Result is drawn on the map as a calculation overlay.": "将你的顶点贴到附近街道。绝不删除点——只会在 OSRM 可行处加入道路细节；弱路段保持你原本绘制的样子。结果会以计算叠加层画在地图上。",
  "Standard": "标准",
  "Start Using App": "开始使用应用",
  "Starting download: {filename}": "开始下载：{filename}",
  "Station names show in Chinese for 廣東話, 繁體中文 and 简体中文; English for others.": "站名：广东话、繁体中文与简体中文显示中文站名；其他语言显示英文。",
  "Step {n} of {m}": "第 {n} 步，共 {m} 步",
  "Stop": "站点",
  "Stop {n}": "站点 {n}",
  "Stops on route": "路线站点",
  "Sub-page actions": "子页面操作",
  "Submit failed": "提交失败",
  "Submit for review": "提交审查",
  "Submit for review — mods publish after check.": "提交审查——版主检查后才会发布。",
  "Submit method": "提交方式",
  "Submit successful": "提交成功",
  "Submitting…": "提交中…",
  "Swap origin and destination": "交换起点与目的地",
  "Switch branch": "切换支线",
  "Switch operator": "切换运营商",
  "Switch branch: {cur} ⇄ {other}": "切换支线：{cur} ⇄ {other}",
  "Switch Departure": "切换开出",
  "Switch direction": "切换方向",
  "Search route": "搜索线路",
  "Search a route first": "请先搜索线路",
  "Search and pick a route first": "请先搜索并选择线路",
  "Loading directions…": "正在加载方向…",
  "{n} directions on this route": "此线路有 {n} 个方向",
  "Tap the map to set": "点击地图以设置",
  "Tap the map to set destination": "点击地图设置目的地",
  "Tap the map to set origin": "点击地图设置出发地",
  "Tap the map to set via": "点击地图设置途经点",
  "Terms": "条款",
  "Terms & Privacy": "条款及隐私",
  "Terms of Service": "服务条款",
  "The map's graphics engine keeps failing. Reload the page to try again.": "地图图形引擎持续故障。请重新加载页面重试。",
  "The terms and policies you agreed to when you first set up Travelers.": "这些是你首次设置 Travelers 时同意的条款与政策。",
  "The transit data has been refreshed on the server. Re-download the offline set to get the latest routes, stops and fares?": "服务器上的交通数据已更新。重新下载离线数据集以获取最新路线、站点与车费？",
  "Third-party software, fonts, and data used by Travelers, with license identifiers and attribution links for compliance.": "Travelers 使用的第三方软件、字体与数据，附许可证标识符与出处链接以符合规定。",
  "Third-party software, fonts, and data used by Travelers, with license identifiers and attribution links for compliance. Last updated 12 Aug 2026 — versions are package ranges; lockfile pins apply at build time. SPDX identifiers as declared upstream; full license text is in each project’s distribution.": "Travelers 使用的第三方软件、字体与数据，附许可证标识符与出处链接以符合规定。最后更新 2026 年 8 月 12 日——版本为包范围；构建时以 lockfile 锁定。SPDX 标识符按上游声明；完整许可证文字在各项目的发布中。",
  "This browser can't render the map — it needs WebGL2 graphics. Update Chrome or Android System WebView and reload.": "此浏览器无法渲染地图——需要 WebGL2 图形。更新 Chrome 或 Android System WebView 后重新加载。",
  "This will delete all cached data, preferences, and onboarded state. Are you sure?": "这将删除所有缓存数据、偏好设置和引导状态。您确定吗？",
  "Ticket / fare type": "票种／车费类型",
  "Ticket type": "票种",
  "Ticket type used for trip plans and bus boarding prices on route details.": "用于行程规划与路线详情中巴士上车价格的票种。",
  "Tickets": "车票",
  "Tile archive format and client loader (Protomaps).": "瓦片存档格式与客户端加载器（Protomaps）。",
  "Timetable · {schedN}/{total} routes · {t}": "时刻表 · {schedN}/{total} 条路线 · {t}",
  "To": "目的地",
  "To {dest}": "往 {dest}",
  "Traffic method": "交通工具",
  "Traffic methods": "交通工具",
  "Traffic methods. None selected shows all.": "交通工具。未选择时显示全部。",
  "Transfer walk": "换乘步行",
  "Transit": "交通",
  "Transit data (Hong Kong)": "交通数据（香港）",
  "Transport Department open data": "运输署开放数据",
  "Travelers panel": "Travelers 面板",
  "Treated as adult Octopus rates": "按成人八达通收费",
  "Trip Plan": "行程规划",
  "Trip Plan · to {name}": "行程规划 · 前往 {name}",
  "Trip detail": "行程详情",
  "Trip plan pinned": "行程计划已固定",
  "Trip plan unpinned": "行程计划已取消固定",
  "Trip-planning engine (RAPTOR); compiled WASM vendored in this repo (Wheels Labs / Wheels Softworks).": "行程规划引擎（RAPTOR）；已编译 WASM 收录于此仓库（Wheels Labs / Wheels Softworks）。",
  "Try another filter or search term": "请尝试其他筛选条件或搜索词",
  "Try different locations or a later departure.": "请尝试其他地点或较晚出发。",
  "Turning off the banner means you understand and agree that predicted live bus positions are inaccurate and for reference only.": "关闭横幅即表示您了解并同意：预测的实时巴士位置不准确，仅供参考。",
  "UI icons, loaded from Google Fonts (Google LLC).": "界面图标，加载自 Google Fonts（Google LLC）。",
  "UI typeface, loaded from Google Fonts (The Montserrat Project Authors).": "界面字体，加载自 Google Fonts（The Montserrat Project Authors）。",
  "UNLOOP MORGAN Universal Terms of Use for Open-Source Software": "UNLOOP MORGAN 开源软件通用使用条款",
  "Undo": "撤销",
  "Undo (⌘/Ctrl+Z)": "撤销（⌘/Ctrl+Z）",
  "Undo · {n} path pts · {u} undo · {r} redo": "撤销 · {n} 个路径点 · 可撤销 {u} 次 · 可重做 {r} 次",
  "Unknown MTR line “{line}”. Try TWL, ISL, KTL, TML, EAL, TCL, TKL, SIL, DRL, or AEL.": "未知的港铁路线“{line}”。请尝试 TWL、ISL、KTL、TML、EAL、TCL、TKL、SIL、DRL 或 AEL。",
  "Unpin": "取消固定",
  "Unpin plan": "取消置顶路线",
  "Unpin stop": "取消置顶站点",
  "Unpin this trip": "取消固定此行程",
  "Unpinned {id}": "已取消固定 {id}",
  "Update available": "有可用更新",
  "Update data": "更新数据",
  "Update frequency": "更新频率",
  "Update now": "立即更新",
  "Updated —": "已更新——",
  "Updated {n}h ago": "{n} 小时前更新",
  "Updated {n}m ago": "{n} 分钟前更新",
  "Updated {n}s ago": "{n} 秒前更新",
  "Uploading path for review": "上传路径以供审查",
  "Use current location": "使用当前位置",
  "Use current location as origin": "使用当前位置作为起点",
  "Use Resident Fare on RBS": "在 RBS 使用居民车费",
  "Usual": "平日",
  "Usual uses weekday timetables; Holiday uses Sunday / public-holiday service.": "平日使用周一至五时刻表；假日使用星期日／公众假期服务。",
  "V path · S visual stops · R follow roads · Tab switch. Official greys stay fixed.": "V 路径 · S 视觉站点 · R 沿路行驶 · Tab 切换。官方灰色点保持固定。",
  "Vector basemap": "矢量底图",
  "Vertex kept raw (OSRM weak)": "顶点保持原始（OSRM 弱）",
  "Vertex snapped to road": "顶点已贴到道路",
  "Visit your PR": "前往你的 PR",
  "Visit {visitN} of {visitTotal} on this route": "此路线第 {visitN}／{visitTotal} 次到访",
  "Visual stop pins (S) — official stays fixed": "视觉站点标记（S）——官方站点保持固定",
  "Visual stops": "视觉站点",
  "Visual stops mode (S)": "视觉站点模式（S）",
  "Visual stops mode (S) — drag orange pins": "视觉站点模式（S）—— 拖动橙色标记",
  "Visual stops re-projected onto path · official coords still fixed": "视觉站点已重新投影到路径 · 官方坐标仍然固定",
  "Visual stops snapped to path (official unchanged)": "视觉站点已吸附到路径（官方位置不变）",
  "Visual stops: no stops loaded — Load calculated path first": "视觉站点：未加载任何站点 —— 请先加载计算路径",
  "Visual stops: {n} orange pins · grey ghost only if moved from official · drag to adjust": "视觉站点：{n} 个橙色标记 · 仅在移离官方位置时显示灰色残影 · 拖动以调整",
  "Via": "途经",
  "Via {n}": "途经 {n}",
  "Via cleared": "已清除途经",
  "Via is the same as the destination": "途经点与目的地相同",
  "Via is the same as the origin": "途经点与出发地相同",
  "Via suggestions": "途经建议",
  "Walk": "步行",
  "Walk to {dest}": "步行至 {dest}",
  "Walk to {to}": "步行至 {to}",
  "Walk to destination": "步行至目的地",
  "Walk to station": "步行至车站",
  "Walk the free link to {place}": "步行免费通道至 {place}",
  "Welcome to MORGAN Travelers": "欢迎使用 MORGAN Travelers",
  "Welcome!": "欢迎！",
  "Yes, cache all data": "是，缓存所有数据",
  "You were running on downloaded data. Restart to load the latest data from the cloud.": "您之前使用的是离线数据。请重新加载以获取云端最新数据。",
  "Your name (optional)": "你的姓名（选填）",
  "You can add up to {n} vias": "最多可以添加 {n} 个途经点",
  "Your path was saved to the review queue.": "你的路径已保存到审查队列。",
  "Your path was submitted and a pull request was opened from your GitHub account.": "你的路径已提交，并已由你的 GitHub 账户打开了 pull request。",
  "Your path was submitted and a review pull request was opened by the site bot.": "你的路径已提交，审查 pull request 已由网站 bot 打开。",
  "Your path was submitted for review.": "你的路径已提交供审查。",
  "another route": "另一条路线",
  "as {author}": "以 {author} 名义",
  "auto after load": "加载后自动",
  "cycle": "切换",
  "default": "默认",
  "desktop": "桌面",
  "e.g. Central Station · @MTR @LRT @Bus": "例如：中环站 · @港铁 @轻铁 @巴士",
  "e.g. Yuen Long Station": "例如：元朗站",
  "e.g. Times Square · meet here": "例如：时代广场 · 在这里会合",
  "e.g. via Mei Tung Street, not terminus bay": "例如：经美东街，非巴士总站",
  "filters.": "筛选器。",
  "fork (credited to you).": "分支打开 PR（归功于你）。",
  "id {id}": "id {id}",
  "min": "分",
  "multi-select": "多选",
  "on this panel).": "拖到此面板）。",
  "path ·": "路径 ·",
  "published path that covers the same corridor; otherwise live OSRM.": "覆盖同一走廊的已发布路径；否则使用实时 OSRM。",
  "roads ·": "道路 ·",
  "route {r}": "路线 {r}",
  "select ·": "选择 ·",
  "similar": "类似",
  "stops ·": "站点 ·",
  "to discard.": "以丢弃。",
  "to keep,": "以保留，",
  "visual stop pins": "视觉站点标记",
  "{base} - Platform {p}": "{base} - {p}号月台",
  "{h} h": "{h} 小时",
  "{h} h {m} min": "{h} 小时 {m} 分钟",
  "{kindLabel} {routeId} → {dest}": "{kindLabel} {routeId} 往 {dest}",
  "{n} min": "{n} 分钟",
  "1 min": "1 分钟",
  "your": "你的",
  "{n} offset points selected": "已选择 {n} 个偏移点",
  "{n} path points on map (stop names unavailable).": "地图上有 {n} 个路径点（暂无站名）。",
  "{n} pinned route{s}": "已固定 {n} 个站点{s}",
  "{n} pinned stop{s}": "已固定 {n} 个站点{s}",
  "{n} plan(s) · {ms} ms": "{n} 个方案 · {ms} 毫秒",
  "{n} plan(s) via {place} · {ms} ms": "{n} 个方案经 {place} · {ms} 毫秒",
  "{n} points selected": "已选择 {n} 个点",
  "{n} points selected · Delete/Backspace to remove · Shift+drag to add": "已选择 {n} 个点 · Delete/Backspace 移除 · Shift+拖动新增",
  "{n} stops": "{n} 个站点",
  "{n}m": "{n} 分",
  "{pts} pts": "{pts} 个点",
  "· green rings = path · orange = visual stop · grey = official fixed": "· 绿色圆环 = 路径 · 橙色 = 视觉站点 · 灰色 = 官方固定",
};